import { call, put, takeLatest } from "redux-saga/effects";
import { CognitoClient } from "../../lib/cognitoClient";
import { handleAuthResponse, handleError, setTranslatableSuccessMessage } from "../actions/loginactioncreators";
import actiontypes from "../actions/actiontypes";
import { mfaToastMessages } from "../../i18n/mfaToastMessages.js";
import { MfaType } from "../../components/mfa/model/MfaType";

export function* answerMfaChoiceChallenge(action) {
    const resendOtp = action.payload.resendOtp ?? false;
    const deliveryMedium = action.payload.deliveryMedium;
    try {
      const cognitoResponse = yield call(CognitoClient.chooseMfaFactor, action.payload.deliveryMedium);
      yield put(handleAuthResponse(cognitoResponse));
  } catch (error) {
    // TODO: This is a hack for a known issue with amplify https://github.com/aws-amplify/amplify-js/issues/6676
    if (resendOtp && error.message === "Invalid code or auth state for the user.") {
      const message = deliveryMedium.toLowerCase() === MfaType.EMAIL ? mfaToastMessages.emailVerificationCodeSent : mfaToastMessages.smsVerificationCodeSent;
      yield put(setTranslatableSuccessMessage(message));
    } else {
      yield put(handleError(error));
    }
  }
}

export function* watchMfaChoiceAnswer() {
  yield takeLatest(actiontypes.MFA_SELECT_TYPE, answerMfaChoiceChallenge);
}